import * as React from 'react';

import {CopyableLink} from 'shells/link/copyable-link';
import {CircleNumber} from 'shells/numbered-breadcrumbs/circle-number';
import {Body} from 'shells/typography/body';

import {getCopyableWrapperInfo} from './helpers';
import type {CopyableLinkVariant} from './types';

type Props = {
    type: CopyableLinkVariant;
    value: string | null | undefined;
    count: number;
};

export function CopyableLinkWrapper(props: Props) {
    const infoData = getCopyableWrapperInfo(props.type);
    if (!infoData) {
        return null;
    }

    return (
        <div className='border br-3 pad-16'>
            {NutClientConfig.hasWordPressForBootSnippetFF && (
                <div className='flex flex-row gap-12 align-center mb-16'>
                    <CircleNumber state='selected' count={props.count} />
                    <Body isBold={true}>{infoData.header}</Body>
                </div>
            )}
            <CopyableLink
                size='big'
                isWhite={true}
                value={props.value || ''}
                label={infoData.label}
                name={infoData.name}
            />
        </div>
    );
}
